import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { reduxForm } from "redux-form";
import { startCase } from "lodash-es";
import { withProps } from "recompose";
import { InputField, wrapDialog } from "@teselagen/ui";
import { compose } from "redux";
import { Button, Intent, Classes } from "@blueprintjs/core";
import classNames from "classnames";
import "./simpleDialog.css";
import { tryToRefocusEditor } from "../utils/editorUtils";
class SimpleGenericDialogForm extends React.Component {
  render() {
    const {
      hideModal,
      handleSubmit,
      fields,
      buttonText = "OK",
      showCancel = true,
      onSubmit,
      invalid,
      extraProps = {}
    } = this.props;
    return /* @__PURE__ */ jsxs(
      "form",
      {
        onSubmit: handleSubmit((data) => {
          if (onSubmit) onSubmit(data);
          hideModal();
          tryToRefocusEditor();
        }),
        onKeyDown: (e) => {
          if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
            handleSubmit((data) => {
              if (onSubmit) onSubmit(data);
              hideModal();
              tryToRefocusEditor();
            })();
          }
        },
        className: classNames(
          Classes.DIALOG_BODY,
          "tg-min-width-dialog simple-dialog"
        ),
        children: [
          fields.map((field, i) => {
            const { component, isRequired, ...props } = field;
            const FieldComp = component || InputField;
            const fieldProps = {
              autoFocus: i === 0,
              ...props,
              ...extraProps[props.name]
            };
            fieldProps.label = fieldProps.label || startCase(fieldProps.name) + ":";
            if (isRequired) fieldProps.validate = required;
            return /* @__PURE__ */ jsx(FieldComp, { ...fieldProps }, field.name);
          }),
          /* @__PURE__ */ jsxs("div", { className: "dialog-buttons", children: [
            showCancel && /* @__PURE__ */ jsx(
              Button,
              {
                onClick: () => {
                  hideModal();
                  tryToRefocusEditor();
                },
                text: "Cancel"
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                type: "submit",
                intent: Intent.PRIMARY,
                text: buttonText,
                disabled: invalid
              }
            )
          ] })
        ]
      }
    );
  }
}
function required(val) {
  if (!val) return "Required";
}
export default function createSimpleDialog(props) {
  return compose(
    wrapDialog({
      isDraggable: true,
      width: 400,
      ...props.withDialogProps
    }),
    reduxForm({
      form: props.formName
    }),
    withProps(props)
  )(SimpleGenericDialogForm);
}
